const SearchField = ({
  query,
  handleUpdateQueryAndSearch,
  handleSearch,
  searched,
  total,
}) => (
  <form
    onSubmit={(event) => {
      event.preventDefault();
      handleSearch();
    }}
    className="search-form"
    role="search"
  >
    <div className="search-form__input-wrapper">
      <input
        placeholder="Typ om te zoeken"
        type="search"
        value={query}
        className={`form-text search-form__input${
          searched ? " has-searched" : ""
        }`}
        onChange={(event) => {
          handleUpdateQueryAndSearch(event.target.value);
        }}
      />
    </div>
    {searched && (
      <div className="search-form__message">
        <b>{`${total} ${total === 1 ? "resultaat" : "resultaten"}`}</b> gevonden
        voor {query !== "" && <b>{`"${query}".`}</b>}
      </div>
    )}
  </form>
);

export default SearchField;
